module.exports = __webpack_public_path__ + "static/media/coins.ef3e3deb.svg";